// Умная предзагрузка - один раз на страницу
let preloadInitialized = false;

const preloadAssets = () => {
  // 🚫 Предотвращаем дублирование
  if (preloadInitialized) {
    console.log('🔄 Preloader already initialized');
    return;
  }
  preloadInitialized = true;

  console.log('🚀 Starting smart media preloading...');

  // 🔍 НАХОДИМ РЕАЛЬНЫЕ ФАЙЛЫ в DOM
  const findRealAssets = () => {
    const foundAssets = {
      images: new Set(),
      videos: new Set()
    };

    // Ищем изображения в DOM
    document.querySelectorAll('img[src]').forEach(img => {
      if (img.src && img.src.startsWith('http') && !img.src.includes('data:')) {
        foundAssets.images.add(img.src);
      }
    });

    // Ищем background-image в CSS
    document.querySelectorAll('*').forEach(element => {
      const style = window.getComputedStyle(element);
      const bgImage = style.backgroundImage;
      if (bgImage && bgImage !== 'none' && bgImage.includes('url(')) {
        const match = bgImage.match(/url\(['"]?([^'"]+)['"]?\)/);
        if (match && match[1] && match[1].startsWith('http')) {
          foundAssets.images.add(match[1]);
        }
      }
    });

    // Ищем видео в DOM
    document.querySelectorAll('video[src], source[src]').forEach(video => {
      if (video.src && video.src.startsWith('http')) {
        foundAssets.videos.add(video.src);
      }
    });

    return foundAssets;
  };

  // 🎯 ПРЕДЗАГРУЖАЕМ ТОЛЬКО НАЙДЕННЫЕ ФАЙЛЫ
  const preloadFoundAssets = () => {
    const assets = findRealAssets();
    
    console.log(`📦 Found ${assets.images.size} images and ${assets.videos.size} videos`);

    if (assets.images.size === 0 && assets.videos.size === 0) {
      console.log('⚠️ No assets found, retrying in 2 seconds...');
      setTimeout(preloadFoundAssets, 2000);
      return;
    }

    // Предзагружаем изображения (максимум 15)
    Array.from(assets.images).slice(0, 15).forEach((src, index) => {
      setTimeout(() => {
        const img = new Image();
        img.onload = () => console.log('✅ Image loaded:', src.split('/').pop());
        img.onerror = () => console.warn('⚠️ Image failed:', src.split('/').pop());
        img.src = src;
      }, index * 100); // Загружаем с интервалом 100мс
    });

    // Предзагружаем видео (максимум 8)
    Array.from(assets.videos).slice(0, 8).forEach((src, index) => {
      setTimeout(() => {
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.muted = true;
        video.playsInline = true;
        video.onloadedmetadata = () => console.log('🎬 Video metadata loaded:', src.split('/').pop());
        video.onerror = () => console.warn('⚠️ Video failed:', src.split('/').pop());
        video.src = src;
      }, 2000 + (index * 200)); // Видео загружаем позже с интервалом 200мс
    });
  };

  // 📱 ОБНАРУЖЕНИЕ УСТРОЙСТВА И СОЕДИНЕНИЯ
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  const isSlowConnection = connection && 
    (connection.effectiveType === 'slow-2g' || connection.effectiveType === '2g');

  if (isSlowConnection) {
    console.log('🐌 Slow connection detected - skipping preload');
    return;
  }

  if (isMobile) {
    console.log('📱 Mobile detected - minimal preload');
    setTimeout(preloadFoundAssets, 3000);
  } else {
    console.log('🖥️ Desktop detected - normal preload');
    setTimeout(preloadFoundAssets, 1000);
  }
};

// 🖼️ Утилита для предзагрузки изображения
export const preloadImage = (src) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error(`Failed to load: ${src}`));
    img.src = src;
  });
};

// 🎬 Утилита для предзагрузки видео
export const preloadVideo = (src, preloadType = 'metadata') => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.preload = preloadType;
    video.muted = true;
    video.playsInline = true;
    
    const onLoad = preloadType === 'metadata' ? 'onloadedmetadata' : 'oncanplaythrough';
    video[onLoad] = () => resolve(video);
    video.onerror = () => reject(new Error(`Failed to load: ${src}`));
    
    video.src = src;
  });
};

// 🧹 Сброс для hot reload в development
if (process.env.NODE_ENV === 'development') {
  if (module.hot) {
    module.hot.accept(() => {
      preloadInitialized = false;
    });
  }
}

export default preloadAssets;